<template>
  <div class="change-base">
    <user-detail-title
      first-bread="标签管理"
      second-bread="产品信息"
      third-bread="产品信息修改"
      first-url="/user/sign"
      second-url="/user/product_info"
      title-name="产品信息修改"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" >

        <el-form-item label="名称" >
          <el-input v-model="Clist.name" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="型号">
          <el-input v-model="Clist.modelNumber" style="width: 500px;"></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-checkbox-group v-model="Clist.labelList" v-if="ChangeData">
            <div v-for="  (item,index) in ChangeData.label" :key="index+'sw'"  >
              <el-checkbox :label="item.id" v-if="item">
                {{item.name}}
              </el-checkbox>
              <br>
              <div style="margin-left: 15px">
                <el-checkbox v-for="(sec,index) in item.tagList" :key="index+'ewe'" :label="sec.id" v-if="sec"
                             v-model="item.checked"
                  >
                  {{sec.name}}
                </el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="型号">
          <el-checkbox-group v-model="Clist.classifyList" v-if="ChangeData">
            <el-checkbox v-for=" (item,index) in ChangeData.classify" :key="index+'ss'" :label="item.id" v-if="item">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="商品介绍">
          <ripeav-text-input v-model="Clist.productIntroduce" />
        </el-form-item>
        <el-form-item label="预览">
          <div v-html="Clist.productIntroduce" />
        </el-form-item>

      </el-form>
    </user-detail-base>
    <el-button @click="handleChange">修改</el-button>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  import RipeavTextInput from "@/components/tinymce/RipeavTextInput";
  export default {
    name: "ProductInfoChange",
    components: {RipeavTextInput, UserDetailBase, UserDetailTitle},
    data(){
      return{
        ChangeData:null,
        Checked:[],

        Clist: {
          'id':this.$route.params.id,
          'name':null,
          'modelNumber':null,
          'photoUrl':null,
          'labelList':[],
          'classifyList':[],
          'productIntroduce':null,
        },//表示Change添加的数据
      }
    },
    created() {
      this.GetChangeData(this.$route.params.id)
    },
    methods:{
      GetUrlList(file){
        this.Clist.photoUrl=file.data;
      },
      GetChangeData(id){
        this.$axios.get('/api/productInfo/checkoutProductBelong',{params:{
            id: id
          }}).then(res=>{
          this.ChangeData=res.data.data;
          this.Checked=res.data.data.checked;
          for (let i = 0; i < this.Checked.length; i++) {
            this.Clist.classifyList.push(this.Checked[i].id)
          };
          for (let i = 0; i < this.ChangeData.label.length; i++) {
            if(this.ChangeData.label[i].tagList !== null){
              for (let j = 0; j < this.ChangeData.label[i].tagList.length; j++) {
                if(this.ChangeData.label[i].tagList[j].checked ==true){
                  this.Clist.labelList.push(this.ChangeData.label[i].tagList[j].id)
                }
              }
            }
          }
        })
      },
      handleChange(){
        if(this.Clist.name || this.Clist.productIntroduce || this.Clist.photoUrl){
          this.$axios.post('/api/productInfo/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message('请选择一项进行上传')
        }
      }
    }
  }
</script>

<style scoped>

</style>